import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

import MainHeader from "./header.vue";
import MainFooter from "./footer.vue";
import suspendLayerVue from "./suspendLayer.vue";
import { useRoute } from "vue-router";
import { computed } from "@vue/reactivity";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const route = useRoute();

const hasCommon = computed(
  () => !route.path.includes("/sub4") && !route.path.includes("/sub6")
);

const noFooterPath = ["/login", "/register", "/changePass"];

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createBlock(_component_a_layout, null, {
    default: _withCtx(() => [
      (_unref(hasCommon))
        ? (_openBlock(), _createBlock(MainHeader, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(_component_a_layout_content, { style: {"background-color":"#ffffff"} }, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      }),
      (!noFooterPath.includes(_unref(route).path) && _unref(hasCommon))
        ? (_openBlock(), _createBlock(MainFooter, { key: 1 }))
        : _createCommentVNode("", true),
      (!noFooterPath.includes(_unref(route).path) && _unref(hasCommon))
        ? (_openBlock(), _createBlock(suspendLayerVue, { key: 2 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})